const m = window.require("@ember/array/proxy");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;